import { PERMISSIONS } from "./constants"

class AppStore {
  plan = $state<PlanType>({} as PlanType)
  subscription = $state<SubscriptionType>({} as SubscriptionType)
  plans = $state<PlanType[]>([])
  current_user = $state<UserType>({} as UserType)
  notifications = $state<NotificationType[]>([])
  users = $state<UserType[]>([])
  onboarding = $state<OnboardingType>({} as OnboardingType)
  external_recipients = $state<ExternalRecipientType[]>([])
  goals = $state<GoalType[]>([])
  tasks = $state<TaskType[]>([])

  params: Record<string, any> = $state({})

  end_of_quarter = $state(new Date())
  end_of_year: Date | string = $state(new Date())
  page = $state("")
  goalParams: Record<string, any> = $state({})
  assignees: AssigneeType[] = $state([])

  beginning_of_quarter = $state<string | Date>("")
  plan_year = $state<number>(0)
  fiscal_year = $state<number>(null)
  time_zones: string[] = $state([])
  headings: string[] = $state([])

  departments = $state<DepartmentType[]>([])
  statements = $state<StatementType[]>([])

  draggedElement = $state({}) as DraggedElementType
  dropElement = $state({}) as DropElementType

  channel_id = $state("")
  meeting_type = $state("")

  get unread_notifications() {
    return this.notifications.filter((not: NotificationType) => !not.read_at)
  }

  flash = $state<any[]>([])

  // Goals
  root_goal = $state({} as GoalType)
  quarterly_goals = $state<GoalType[]>([])

  // Activities
  date_start_str: string = $state("")
  date_end_str: string = $state("")
  dateStart: Date = $state(null)
  dateEnd: Date = $state(null)

  // recognitions
  recognitions = $state<RecognitionType[]>([])
  recognition_stats = $state({})

  // meetings
  update_goals = $state(false)
  update_core = $state(false)
  is_leadership = $state(false)
  plan_review = $state({})
  trackStatement = $state<{ edited: boolean; status: string }>({
    edited: false,
    status: ""
  })
  dates = $state({} as DatesType)
  today = $state(new Date())
  last_meeting_date = $state(new Date())
  meeting = $state<MeetingType>({} as MeetingType)
  editable = $state(false)

  // community
  showNewPost = $state(false)
  channelPosts: ForumPostType[] = $state([])
  permission_level = $state("none")
  current_channel = $state<ForumChannelType>({} as ForumChannelType)
  comment = $state<ForumPostCommentType>({} as ForumPostCommentType)

  // university
  current_book: BookType = $state(null)
  admin_university: boolean = $state(false)
  course: CourseType = $state(null)
  categories: string[] = $state([])

  // onboarding
  role: string = $state("")
  
  // Flywheel
  flywheel: FlywheelType = $state(null)

  // Alignment Test
  alignment_current_step: number = $state(0)

  // Permissions
  hasPermission(section: AppSectionType) {
    return PERMISSIONS[this.current_user.role].includes(section)
  }
  // Updates a list of statements for a section type
  updateStatements(data: StatementType[], section_type: string) {
    let statementsCopy = appStore.statements.filter((s) => s.section_type !== section_type)

    statementsCopy = [...statementsCopy, ...data]
    
    this.statements = statementsCopy
  }

  // Update a single statement
  updateStatement(statement: StatementType) {
    const appStoreidx = this.statements.findIndex(
      (st) => st.id === statement.id
    )

    if (appStoreidx > -1) {
      this.statements[appStoreidx] = statement
    }
  }

  convertUsersHash(users_hash) {
    let users = (Object.values(users_hash) as UserType[]).filter(
      (u: UserType) => !u.deleted && u.role !== "coach"
    )
    users = users.map((u) => {
      return { ...u, edit: false, showDetail: false }
    })
    return users
  }

  admin = $state<UserType>({} as UserType)
  alignment_only_members = $state<UserType[]>([])
  user_roles = $state<PlanUserRoleType[]>([])
}

export const appStore = new AppStore()
